import { Layout, Row, Col } from "antd";
import * as React from "react";
import { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import SideMenu from "../side-menu/side-menu";
import { AuthContext } from "src/components/context/AuthContext";
import { ServiceContext } from "src/services/provider/Service.provider";
import { OfficerHeader } from "./Header";
import { isBlackDecember } from "src/util/blackDecember";

import * as Logo from "src/assets/logos/precatorios-brasil/logo.svg";

import "./main-layout.scss";
import "./content.scss";

export interface IMainLayoutProps {
  style?: React.CSSProperties;
  className?: string;
}

export function MainLayout(props: IMainLayoutProps & JSX.ElementChildrenAttribute) {
  const { documentService } = useContext(ServiceContext);
  const { Sider, Content, Footer } = Layout;
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [menuClicked, setMenuClicked] = useState<string>("");
  const { currentUser } = useContext(AuthContext);
  const [imgSrc, setImgSrc] = useState("");

  const isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }

  useEffect(() => {
    documentService
      .downloadOfficerLogo(currentUser.officer.logoFileKey)
      .then(res => {
        const reader = new FileReader();
        reader.readAsDataURL(res.data);
        reader.onload = () => {
          const imageDataUrl = reader.result;
          setImgSrc(imageDataUrl as string);
        };
      })
      .catch(err => {
        console.error("Falha ao obter a imagem do officer.");
        console.error(err);
      });
  }, []);

  useEffect(() => {
    function handleCollapseSider() {
      if (getSize().width < 650) {
        setSidebarOpen(false);
      } else if (getSize().width > 650) {
        setSidebarOpen(true);
      }
    }

    window.addEventListener("resize", handleCollapseSider);
  }, []);

  useEffect(() => {
    if (getSize().width < 650 && menuClicked) {
      setSidebarOpen(false);
      setMenuClicked("");
    }
  }, [menuClicked]);

  return (
    <Layout className={`main-layout ${props.className ? props.className : ""} ${isBlackDecember ? "theme-black-december" : ""}`}>
      <Sider
        trigger={null}
        collapsible
        collapsed={!sidebarOpen}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0
        }}
        breakpoint="lg"
        collapsedWidth="0"
        width={250}
      >
        <img src={imgSrc} style={{ padding: "30px 20px 20px", maxWidth: "100%" }} />
        <SideMenu setMenuClicked={setMenuClicked} />
      </Sider>
      <Layout style={{ marginLeft: sidebarOpen ? 250 : 0 }}>
        <OfficerHeader currentUser={currentUser} setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} isBlackFriday={isBlackDecember} />
        <Content>{props.children}</Content>
        <Footer style={{ textAlign: "center" }}>
          {isBlackDecember ? (
            <Row type="flex" style={{ alignItems: "center" }}>
              <Col
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  paddingRight: "6px",
                  paddingLeft: "6px",
                  borderRadius: "8px",
                  position: "relative",
                  background: "transparent"
                }}
              >
                <img src={Logo} style={{ height: "80px" }} />
                {/* <span>Parceiros</span> */}
              </Col>
              <Col
                style={{
                  marginLeft: "auto",
                  marginRight: "auto"
                }}
              >
                <Link to="/">BTG Pactual</Link> ©{new Date().getFullYear()}
              </Col>
            </Row>
          ) : (
              <>
                <Link to="/">BTG Pactual</Link> ©{new Date().getFullYear()}{" "}
              </>
            )}
        </Footer>
      </Layout>
    </Layout>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/main-layout/MainLayout.tsx